export default __webpack_public_path__ + "4d1ef57.png";